import { format } from 'date-fns';

import { BillingAccount } from '@mfe/shared/schema-types';

export function getNextBillCycleDate(billingAccount: BillingAccount) {
  const nextBillingCycleDate = billingAccount?.nextBillPeriodStartDate
    ? format(billingAccount?.nextBillPeriodStartDate, 'MMM dd')
    : '';
  return nextBillingCycleDate;
}
